import React from 'react'

const Footer = () => {
  return (
    <div className=' flex w-full bg-[#010203] items-center justify-center text-white h-20 font-bold lg:text-2xl sm:text-xl'>
        <span>Made with ❤️ @FashionHub24</span>
    </div>
  )
}

export default Footer